<template>
<div>
    <div class="d-flex">
        <h2 class="titleText--text">{{title}}</h2>
        <v-tooltip right v-if="helpicon">
        <template v-slot:activator="{ on, attrs }">
            <v-icon size="medium" v-bind="attrs"
            v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
        </template>
        <slot name="help-content" />
        </v-tooltip>
    </div>
    <v-card flat class="custom-shadow mt-2" rounded>
        <slot v-if="noPadding" name="widget-content" />
        <v-card-text v-else class="px-6">
            <slot name="widget-content" />
        </v-card-text>
    </v-card>
</div>
</template>

<script>
export default {
    name: 'AppWidget',
    props: {
        title: {
            type: String,
            default: '',
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        helpcontent: {
            type: String,
            default: '',
        },
        helpheading: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'mdi-dots-vertical',
        },
        imgname: {
            type: String,
            default: 'home--v5.png',
        },
        titleicon: {
            type: String,
            default: 'mdi-dots-vertical',
        },
        headerHide: Boolean,
        paddingHide: Boolean,
        headingicon: Boolean,
        headingendicon: Boolean,
        helpicon: Boolean,
    },
    data() {
        return {
            dialog: false,
            items: [{
                    title: 'Home',
                    icon: 'mdi-view-dashboard'
                },
                {
                    title: 'About',
                    icon: 'mdi-forum'
                },
            ],
        }
    },
     computed:{
           getImgname(){
               let imgpath=this.imgname;
               return imgpath;
           }
     }
};
</script>

<style>
.header-icon-space {
    padding-right: 10px !important;
}
.header-title-style {
    font-size: 15px !important;
}
.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important
}
</style>
